import { render, staticRenderFns } from "./ClassDetailsModal.vue?vue&type=template&id=400c951e&"
import script from "./ClassDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ClassDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ClassDetailsModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports